import React, { useEffect, useState } from "react";
import user from "../../assets/img/user 1.svg";
import dele from "../../assets/img/slash.svg";
import edit from "../../assets/img/edit-3.svg";
import save from "../../assets/img/save.svg";
import greensave from "../../assets/img/greensave.svg";
import comm from "../../assets/img/message-circle.svg";
import like from "../../assets/img/heart.svg";
import likered from "../../assets/img/heart-red.svg";
import { formatDistanceToNow, formatDistance } from 'date-fns';

import { BrowserRouter as Router, Switch, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import {
  deletePost,
    getAllComments
} from "../../services/apiPosts";
import Button from 'react-bootstrap/Button';
import { getSinglePostDetails } from "../../services/apiOtherlink";
import { API } from "../../services/api";
import ProfileQuestion from "../ProfileQuestion/ProfileQuestion";
import CreatePost from "./CreatePost";
import Confirmpopup from "../../commonComponents/Confirmpopup";
import ResponsePopup from "../../commonComponents/responseSucessPopup";

const SinglePost = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state || {};
    
    const [visibleComments, setVisibleComments] = useState({});
    const [showComment, SetShowComments] = useState([]);
    const [postArr, SetPostArr] = useState(null);
    const [open, setOpen] = useState(false);
    const [validationError, setValidationError] = useState(false);
    const [EditStatus, setEditStatus] = useState(false);
    const [EditFeed, setEditFeed] = useState([]);
    const[isConfirm,setConfirm]=useState(false);
     const[DeletPostid,setDeltePostId]=useState('');
      const[isSucess,SetSucess]=useState(false);
        const[ResponseMessage,SetResponseMessage]=useState("");
    const userData = JSON.parse(localStorage.getItem('userData'));
    const OpenPopup = () => {
    setOpen(true);
  }
  const ClosePopup = () => {
    setOpen(false);
    setEditStatus(false);
  }
    useEffect(() => {
        getSinglePost();
    }, [location.state])
    const getSinglePost = async () => {
        const formData = {
            postid: data.PostId
        }
        
        let postDetails = await getSinglePostDetails(formData);
        
        SetPostArr(postDetails.post[0]);

    };
    const slugify = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");


    const handleImageClick = (first, last, id, type) => {
        if (type === "individual") {
             const userName = `${slugify(first)}-${slugify(last)}`;
            if (userData._id === id)
                navigate('/profile');
            else
                navigate(`/profile/${userName}`, { state: { userId: id } })
        } else {
            if (userData._id === id)
                navigate('/organization');
            else
                navigate(`/organization/${slugify(first)}`, { state: { userId: id } })
        }

    };

    const toggleCommentsVisibility = async (postId) => {
        setVisibleComments((prev) => {
          const newVisibility = !prev[postId]; // Determine new visibility state
          // Call the API only if the new visibility state is true (i.e., comments are opening)
          if (newVisibility) {
            const comntpayload = { postid: postId };
            getAllComments(comntpayload).then(resComments => {
              SetShowComments(resComments.comments || []);
            }).catch(err => {
              console.error("Error fetching comments:", err);
            });
          }
          return {
            ...prev,
            [postId]: newVisibility, // Toggle visibility for the specific post
          };
        });
      };

      const handleDelete = async (postid) => {
            setConfirm(false);
          let deletepayload = { postid: postid };
          let response = await deletePost(deletepayload);
          if (response.status === true) {
            SetSucess(true);
            SetResponseMessage("Post is Deleted!");
            navigate('/justlikeme');
          }
      
        }

      const DeletPost = async (postid) => {
        setConfirm(true);
        setDeltePostId(postid);
  };

    return (
        <div className="community-features main ml-0">
        <div className="contents ml-0">
        <div className="profile-section">
            <div className="single posts">
                <div className="user-post">
                    <div className="p-img">
                        <div className="post-avatr-wrap">
                            <img src={postArr?.user[0]?.profileImage?.url ? API.uploadFilePath + postArr?.user[0]?.profileImage?.url : user} className="avar-post" alt="User Profile"
                                style={{ cursor: "pointer", }} onClick={() => {
                                    handleImageClick(postArr?.user[0]?.firstName, postArr?.user[0]?.lastName, postArr?.user[0]?._id, postArr?.user[0]?.userType);
                                }}
                            />


                            {/* Dynamically set user name */}
                            {postArr?.user?.[0] && (
                                <span className="avatarname-post" style={{ cursor: "pointer" }}
                                    onClick={() => handleImageClick(postArr?.user[0]?.firstName, postArr?.user[0]?.lastName, postArr?.user[0]?._id, postArr?.user[0]?.userType)}>
                                    {postArr.user[0].lastName
                                        ? `${postArr.user[0].firstName} ${postArr.user[0].lastName}`
                                        : postArr.user[0].firstName}
                                </span>
                            )}


                            {postArr?.usercommunities?.length > 0 && postArr.usercommunities[0]?.membertype.length > 0 ? (
                                <span className="avatarname-wrp">{postArr.usercommunities[0]?.membertype[0]?.memberTypeDisplayName}</span>
                            ) : (
                                <span className="avatar-role"></span>
                            )}



                           
                        </div>
                    </div>
                </div>

                <div className="community-itmpost-right">
                    <h5 className="comunity-name-post mb-0"></h5>
                    {postArr?.postcommunity && postArr?.postcommunity?.length > 0 && (
                        <span className="user-role-wp border-0">{postArr?.postcommunity?.length > 0 ? postArr.postcommunity[0]?.communityName : ""}</span>
                    )} 

                     {postArr?.topic?.length > 0 && (
                        <span className="user-role-wp">{postArr?.topic?.length > 0 ? postArr?.topic[0]?.topicTitle : ""}</span>
                    )} 


                    <div className="moreoption">

                        

                    </div>
                </div>

            </div>

            <p className="post-tittle"><strong>{postArr?.postTitle}</strong></p>
      <div className="post-content" dangerouslySetInnerHTML={{ __html: postArr?.postDescription }} />
      <div className="user-like_coment-share">
        <div className="like_comment">
          <div className="l-Cwrapper">
            <img src={comm} className="comment-icon" alt="Comments" /><span>{postArr?.comments?.length > 0 ? postArr?.comments[0]?.totalcomments : ""}</span>
            <Link onClick={(e) => { e.preventDefault(); toggleCommentsVisibility(postArr?._id) }}>Comments</Link>
          </div>
          <div className="l-Cwrapper ">
            <img
              src={like}
              className="comment-icon"
              alt="Likes"
             
            /><span>{postArr?.likes?.length > 0 ? postArr?.likes[0]?.totallikes : ""}</span>
            Likes
          </div>



        </div>

        
      </div>
      {/* Comment Input Section */}
      <div className="text-space comment-box-post">
        
        {/* List Comments Section */}
        {visibleComments[postArr?._id] && showComment.length > 0 && (
          <div>{/* Wrap the elements in a parent div */}
            
            <div className="comments-wrapper">
              {showComment.map((comment, index) => (

                <div key={index} className="comment-itm d-flex">
                  {comment.userId.profileImage ? (
                    comment.userId.profileSettings.isPrivateProfile === false &&
                      comment.userId.profileSettings.showprofileImage === true ? (
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + comment.userId.profileImage.url}
                        className="avar-logo people-user comment"
                        alt="User"
                      />
                    ) : (
                      <img src={user} className="avar-logo people-user comment" alt="User" />
                    )
                  ) : (
                    <img src={user} className="avar-logo people-user comment" alt="User" />
                  )}

                  <div className="coment-box d-flex flex-column">
                    <div className="text-comment d-flex justify-content-between">
                      <div className="avatar_name">{comment.userId.firstName} {comment.userId.lastName}</div>
                      <span className="date-sec"> {formatDistanceToNow(new Date(comment.createdAt), { addSuffix: true })}</span>
                    </div>
                    <p>{comment.comment}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>


        </div>
        </div>
     <ProfileQuestion type="profile"/>

     <CreatePost openPop={open} closePop={ClosePopup} EditStatus={EditStatus} EditFeed={EditFeed} fetchAllFeeds={getSinglePost}></CreatePost>
     {isConfirm && (<Confirmpopup 
                isConfirm={isConfirm}
                DeletPostid={DeletPostid} 
                handleDelete={handleDelete}
                type="post"
                CancelPopup={() => { 
                  setConfirm(false);
                }} 
                                  
              />)}  
              {isSucess && (<ResponsePopup
                isSucess={isSucess} 
                CancelPopup={() => { 
                 SetSucess(false);
                }} 
                message={ResponseMessage}
              />)}
        </div>
    )


};
export default SinglePost;